export const onClientEntry = function() {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (typeof window.IntersectionObserver === `undefined`) {
    import(`intersection-observer`).then(() => {
      console.log(`# IntersectionObserver is polyfilled!`);
    });
  }
};
